import { API_URL } from '../circulusConfig';
// import { encodeGetParams, getHeaders } from '../common/util';
import { encodeGetParams } from '../common/util';
// import { POST, PATCH, PUT } from '../common/consts';

const getUserHistoriesAPI = async ({ robotId, ...rest }) => {
  const res = await fetch(
    `${API_URL}history/${robotId}?${encodeGetParams(rest)}`,
  );
  const result = res.json();
  return result;
};

// const setUserRobotsAPI = async ({ userId, robots }) => {
//   const res = await fetch(
//     `${API_URL}robots`,
//     getHeaders(POST, { userId, robots }),
//   );
//   const result = res.json();
//   return result;
// };

// const updateUserRobotsAPI = async ({ userId, robots }) => {
//   const res = await fetch(
//     `${API_URL}robots`,
//     getHeaders(PATCH, { userId, robots }),
//   );
//   const result = res.json();
//   return result;
// };

// const deleteUserRobotsAPI = async ({ userId, robots }) => {
//   const res = await fetch(
//     `${API_URL}robots`,
//     getHeaders(PUT, { userId, robots }),
//   );
//   const result = res.json();
//   return result;
// };

export {
  getUserHistoriesAPI
};
